module.exports = __webpack_public_path__ + "static/media/wmTrial-words-1.d3cd087e.mp3";